import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ExecChatAction } from '../../../../constants/chatActions';

export type ChatUiMessage = {
    user?: {
        message: string;
        files: unknown[];
        sort?: number;
        createdAt?: Date;
        stage?: string;
        flow?: string;
    };
    agent?: {
        message?: string;
        files?: unknown[];
        createdAt?: Date;
        _id?: string;
        stage?: string;
        options?: unknown;
    };
};

/** Quick-action payload; same shape as legacy CHAT_ACTIONS items */
export type ChatUiAction = ExecChatAction | { name: string; text: string; enum: string };

interface ChatUIState {
    open: boolean;
    chatId?: string;
    chatData?: ChatUiMessage[];
    action?: ChatUiAction;
}

const initialState: ChatUIState = {
    open: false,
    chatId: undefined,
    chatData: undefined,
    action: undefined,
};

export const chatsUISlice = createSlice({
    name: 'chatsUI',
    initialState,
    reducers: {
        openChat(
            state,
            action: PayloadAction<{
                chatId?: string;
                data?: ChatUiMessage[];
                action?: ChatUiAction;
            }>,
        ) {
            state.open = true;
            state.chatId = action.payload.chatId;
            state.chatData = action.payload.data;
            state.action = action.payload.action;
        },
        closeChat(state) {
            state.open = false;
            state.chatId = undefined;
            state.chatData = undefined;
            state.action = undefined;
        },
    },
});
export const { openChat, closeChat } = chatsUISlice.actions;

export default chatsUISlice.reducer;